/**
 * Created by Samyan Wahla on 9/21/2015.
 */
(function () {
    angular.module('tmx-app')
        .factory('RegistrationUserDataService', function () {
            var service = {};
            service.user = {};

            return service;
        });
})();